import React from 'react';
import { ReactQueryDevtools } from 'react-query/devtools';

export function MaybeDevTools() {
  return <ReactQueryDevtools initialIsOpen={false} />;
}
